import { useEffect, useState } from "preact/hooks";

import { getLimitations } from "@/api";

export const limitationsPromise = getLimitations();

/**
 * @param {string} limitation_type
 * @param {number=} limit
 * @return {boolean}
 */
export const useLimitation = (limitation_type, limit = 0) => {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    limitationsPromise.then((limitations) => {
      limitations.forEach((limitation) => {
        if (limitation.type === limitation_type) {
          setIsAllowed(limitation.limit === -1 || limitation.limit > limit);
        }
      });
    });
  }, []);

  return isAllowed;
};
